import { http } from 'vue'
let r1 = false
let r2 = false
let resource = 'subcategories'
export default {
  loadSubcategories (context, params) {
    return http.get(resource + '?category_id=' + params.categoryId + '&with=counter&sort=name&per_page=' + 9999, {
      before (request) {
        if (r1) r1.abort()
        r1 = request
      }
    })
  },
  // load client from the API server
  loadSubcategory (context, params = {}) {
    let withParam = params.with ? '?with=' + params.with : ''
    return http.get(resource + '/' + params.id + withParam, {
      before (request) {
        if (r2) r2.abort()
        r2 = request
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/subcategories/actions.js